import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const getImportStatus = async ({ signal }) => {
    const user = getUserDetails();

    const response = await axios.get(
        `${API_BACKEND_URL}/testcase/status-context?companyid=${user.companyid}`,
        { signal },
    )
    return response.data;
};

// Progress of the import running on the server. Polled only while one is in flight.
export const useImportStatus = (enabled) => {
    return useQuery({
        queryKey: ["importStatus"],
        queryFn: ({ signal }) => getImportStatus({ signal }),
        enabled,
        refetchInterval: 1500,
        gcTime: 0,
    });
};

const fetchCollectionFromRepo = async({repoLink, gitUsername, gitToken, generate=0, signal}) => {
    const user = getUserDetails();

    const response = await axios.get(
        `${API_BACKEND_URL}/extractor/fetch?repo=${repoLink}&gitUsername=${gitUsername}&gitToken=${gitToken}&generate=${generate}&companyId=${user.companyid}`,
        { signal },
    )

    return response.data;
}

export const useFetchCollectionFromRepo = (options = {}) => {
    return useMutation({
        mutationFn: fetchCollectionFromRepo,
        meta: { silent: true },
        ...options,
    })
}




const generateCollectionsFromSwagger = async({file, signal}) => {
    const user = getUserDetails();
    const response = await axios.post(
        `${API_BACKEND_URL}/extractor/generate?companyId=${user.companyid}`,
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            signal,
        }
    )
    return response.data;
}

export const useGenerateCollectionsFromSwagger = (options = {}) => {
    return useMutation({
        mutationFn: generateCollectionsFromSwagger,
        meta: { silent: true },
        ...options,
    })
}